import { downgradeComponent } from "@angular/upgrade/static";
import { VNavBarComponent } from "@directives/_core/v-nav-bar/v-nav-bar.component";
import { VNavItemComponent } from "@directives/_core/v-nav-bar/v-nav-item/v-nav-item.component";
import * as angular from "angular";
import { VButtonComponent } from "./v-button/v-button.component";
import { VButtonDropdownComponent } from "./v-dropdown/v-button-dropdown/v-button-dropdown.component";
import { VDropdownComponent } from "./v-dropdown/v-dropdown.component";
import { VItemDropdownComponent } from "./v-dropdown/v-item-dropdown/v-item-dropdown.component";

export const CoreModuleName = "app.core.directives";

angular
    .module(CoreModuleName, [])

    .directive("vDropdown", downgradeComponent({ component: VDropdownComponent }))
    .directive("vItemDropdown", downgradeComponent({ component: VItemDropdownComponent }))

    .directive("vButton", downgradeComponent({ component: VButtonComponent }))
    .directive("vButtonDropdown", downgradeComponent({ component: VButtonDropdownComponent }))
    .directive("vNavBar", downgradeComponent({ component: VNavBarComponent }))
    .directive("vNavItem", downgradeComponent({ component: VNavItemComponent }))

    ;
